import { z } from 'zod'
import { furnitureItemDtoSchema } from './furniture-item.dto.js'

/**
 * One entry in the event planner's furniture gallery — a piece the planner can
 * browse close-up. `source` is where it comes from: `venue` (owned stock, which
 * is auto-available in every phase's sidebar — the gallery is just for browsing
 * it) or `vendor` (a rental, opt-in). For a vendor piece, `vendorName`/
 * `vendorLocation` name the supplier and `selectedCount` is how many this event
 * currently rents (0 = not selected). `availableCount` is the cap: the venue's
 * total owned stock, or the vendor's stock.
 */
export const galleryItemDtoSchema = z.object({
  item: furnitureItemDtoSchema,
  source: z.enum(['venue', 'vendor']),
  availableCount: z.number().int().nonnegative(),
  vendorId: z.string().uuid().nullable(),
  vendorName: z.string().nullable(),
  vendorLocation: z.string().nullable(),
  selectedCount: z.number().int().nonnegative(),
})

export type GalleryItemDto = z.infer<typeof galleryItemDtoSchema>

export const furnitureGalleryDtoSchema = z.object({
  items: z.array(galleryItemDtoSchema),
})

export type FurnitureGalleryDto = z.infer<typeof furnitureGalleryDtoSchema>
